import { Component } from "@angular/core";

@Component({
  selector: "icn-autopilot-nav",
  templateUrl: "./autopilot-nav.component.html",
  styleUrls: ["../common/sideNav/sidebar-nav.component.scss"],
})
export class AutopilotNavComponent {}
